import { useState, useEffect } from 'react';
import { getNotificationTypeIcon, getTimeAgo } from './Notifications';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router';

export const NotificationTrayCompact = ({ notifications, fetchNotifications }) => {
    const navigate = useNavigate();

    const readNotification = async (notification) => {
        try {
            const response = await fetch(`https://api.casedb.co/notifications.php?read=${notification.id}`, {
                method: 'GET',
                credentials: 'include'
            });
            const data = await response.json();
            if (data.success) {
                fetchNotifications();
            }
        } catch (error) {
            console.error("Error marking notification as read:", error);
        }

        if (notification.url) {
            navigate(notification.url ? notification.url.startsWith("/") ? `${notification.url}${notification.id ? `?key=${notification.id}` : ''}` : `/${notification.url}${notification.id ? `?key=${notification.id}` : ''}` : null);
        }
    }

    return (
        <div className='notification-tray-compact'>
            {notifications.length > 0 ? (
                <>
                    {notifications.slice(0, 5).map((notification, index) => (
                        <div 
                            className='notification-compact-item' 
                            key={index} 
                            onClick={() => readNotification(notification)} 
                            style={{cursor: notification.url ? 'pointer' : 'default'}}
                        >
                            <div className='notification-compact-icon'>
                                {getNotificationTypeIcon(notification.type, 18, notification)}
                            </div>
                            <div className='notification-compact-content'>
                                <div className='notification-compact-title'>
                                    {!notification.read_at && <div className='notification-new-dot'></div>}
                                    {notification.title.length > 40 ? `${notification.title.slice(0, 40)}...` : notification.title}
                                </div>
                                <div className='notification-compact-time'>
                                    {getTimeAgo(notification.created_at)}
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className='notification-compact-footer' onClick={() => navigate('/notifications')}>
                        <span>View all notifications</span>
                        <ArrowRight size={16}/>
                    </div>
                </>
            ) : (
                <div className='notification-compact-empty'>
                    <p>No new notifications</p>
                </div>
            )}
        </div>
    )
};
